

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import styles from '../../src/assets/scss/AddInviteForm.module.scss';

// const AddInvite = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     userType: '',
//   });

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === 'phone') {
//       // Prevent typing if not starting with 6-9
//       if (value && !/^[6-9]/.test(value)) return;
//       if (value.length > 10) return;
//       if (!/^\d*$/.test(value)) return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleCancel = () => {
//     setFormData({
//       name: '',
//       phone: '',
//       email: '',
//       userType: '',
//     });
//     navigate(-1);
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = 'Name is required';
//     if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
//     else if (!/^[6-9]\d{9}$/.test(formData.phone)) newErrors.phone = 'Enter valid 10-digit number starting with 6-9';
//     if (!formData.email.trim()) newErrors.email = 'Email is required';
//     else if (!/^\S+@\S+\.\S+$/.test(formData.email)) newErrors.email = 'Invalid email format';
//     if (!formData.userType.trim()) newErrors.userType = 'User Type is required';
//     return newErrors;
//   };

// const handleSubmit = (e) => {
//   e.preventDefault();
//   const validationErrors = validate();

//   if (Object.keys(validationErrors).length === 0) {
//     console.log('Form Submitted:', formData);

//     // ✅ Reset the form
//     setFormData({
//       name: '',
//       phone: '',
//       email: '',
//       userType: '',
//     });

//     setErrors({});
//   } else {
//     setErrors(validationErrors);
//   }
// };


//   return (
//     <div className={styles.addInviteContainer}>
//       <div className={styles.header}>
//         <h2 className={styles.tittle}>Add Invite</h2>
//         <span className={styles.closeIcon} onClick={handleCancel}>✕</span>
//       </div>

//       <form className={styles.form} onSubmit={handleSubmit}>
//         <div className={styles.row}>
//           <div className={styles.inputGroup}>
//             <label className={styles.inputLabel}>Name</label>
//             <input
//               className={styles.input}
//               type="text"
//               placeholder="Store Owner"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               onKeyDown={(e) => {
//                 if (e.target.selectionStart === 0 && e.key === " ") {
//                   e.preventDefault();
//                 }
//               }}
//             />
//             {errors.name && <span className={styles.error}>{errors.name}</span>}
//           </div>

//           <div className={styles.inputGroup}>
//             <label className={styles.inputLabel}>Phone Number</label>
//             <input
//               className={styles.input}
//               type="text"
//               placeholder="+91 7898897561"
//               name="phone"
//               value={formData.phone}
//               onChange={handleChange}
//               onKeyDown={(e) => {
//                 if (e.target.selectionStart === 0 && e.key === " ") {
//                   e.preventDefault();
//                 }
//               }}
//             />
//             {errors.phone && <span className={styles.error}>{errors.phone}</span>}
//           </div>
//         </div>

//         <div className={styles.row}>
//           <div className={styles.inputGroup}>
//             <label className={styles.inputLabel}>Email ID</label>
//             <input
//               className={styles.input}
//               type="email"
//               placeholder="cropwork@gmail.com"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               onKeyDown={(e) => {
//                 if (e.target.selectionStart === 0 && e.key === " ") {
//                   e.preventDefault();
//                 }
//               }}
//             />
//             {errors.email && <span className={styles.error}>{errors.email}</span>}
//           </div>

//           <div className={styles.inputGroup}>
//             <label className={styles.inputLabel}>User Type</label>
//             <select
//               className={styles.inputs}
//               name="userType"
//               value={formData.userType}
//               onChange={handleChange}
//             >
//               <option value="">Select User Type</option>
//               <option value="Customer">Customer</option>
//               <option value="Admin">Admin</option>
//               <option value="Vendor">Vendor</option>
//             </select>
//             {errors.userType && <span className={styles.error}>{errors.userType}</span>}
//           </div>
//         </div>

//         <div className={styles.buttonGroup}>
//           <button type="button" className={styles.cancelButton} onClick={handleCancel}>Cancel</button>
//           <button type="submit" className={styles.sendButton}>Send Invite</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default AddInvite;


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../src/assets/scss/AddInviteForm.module.scss';
import { useSendInviteMutation, useUserTypeQuery } from '../slices/admin/admin';
import { toast } from 'react-toastify';

const AddInvite = () => {
  const navigate = useNavigate();

  const { data: userTypeData = {}, isLoading: userTypeLoading, isError } = useUserTypeQuery({
    offset: 1,
    limit: 100,
    isActive: true,
    search: '',
  });
  const userTypeList = userTypeData.result || [];

  //console.log(userTypeList, "userTypeList99");

  const [sendInvite, { isLoading: isSending }] = useSendInviteMutation();


  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    userType: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      if (value && !/^[6-9]/.test(value)) return;
      if (value.length > 10) return;
      if (!/^\d*$/.test(value)) return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    setFormData({
      name: '',
      phone: '',
      email: '',
      userType: '',
    });
    navigate(-1);
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    else if (!/^[6-9]\d{9}$/.test(formData.phone)) newErrors.phone = 'Enter valid 10-digit number starting with 6-9';
    //if (!formData.email.trim()) newErrors.email = 'Email is required';
    //else if (!/^\S+@\S+\.\S+$/.test(formData.email)) newErrors.email = 'Invalid email format';
    if (!formData.userType.trim()) newErrors.userType = 'User Type is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      const payload = {
        name: formData.name.trim(),
        phone: formData.phone.trim(),
        email: formData.email.trim(),
        type: formData.userType,
      };

      try {
        const response = await sendInvite(payload).unwrap();
        toast.success(response.message || 'Invitation sent successfully');

        // Reset form
        setFormData({
          name: '',
          phone: '',
          email: '',
          userType: '',
        });
        setErrors({});
        navigate(-1); // Go back to previous page
      } catch (error) {
        toast.error(error?.data?.message || 'Failed to send invitation');
      }
    } else {
      setErrors(validationErrors);
    }
  };


  return (
    <div className={styles.addInviteContainer}>
      <div className={styles.header}>
        <h2 className={styles.tittle}>Send Invite</h2>
        <span className={styles.closeIcon} onClick={handleCancel}>✕</span>
      </div>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.row}>
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Name</label>
            <input
              className={styles.input}
              type="text"
              placeholder="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.target.selectionStart === 0 && e.key === " ") {
                  e.preventDefault();
                }
              }}
            />
            {errors.name && <span className={styles.error}>{errors.name}</span>}
          </div>

          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Phone Number</label>
            <input
              className={styles.input}
              type="text"
              placeholder="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.target.selectionStart === 0 && e.key === " ") {
                  e.preventDefault();
                }
              }}
            />
            {errors.phone && <span className={styles.error}>{errors.phone}</span>}
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Email ID</label>
            <input
              className={styles.input}
              type="email"
              placeholder="Email ID"
              name="email"
              value={formData.email}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.target.selectionStart === 0 && e.key === " ") {
                  e.preventDefault();
                }
              }}
            />
            {errors.email && <span className={styles.error}>{errors.email}</span>}
          </div>

          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>User Type</label>
          
            <select
              className={styles.inputs}
              name="userType"
              value={formData.userType}
              onChange={handleChange}
              disabled={userTypeLoading}
            >
              <option value="">Select User Type</option>
              {userTypeList.map((type) => (
                <option key={type._id} value={type.usertype}>
                  {type.usertype} [{type.description}]
                </option>
              ))}
            </select>

            {errors.userType && <span className={styles.error}>{errors.userType}</span>}
            {isError && <span className={styles.error}>Failed to load user types</span>}
          </div>
        </div>

        <div className={styles.buttonGroup}>
          <button type="button" className={styles.cancelButton} onClick={handleCancel}>Cancel</button>
          <button
            type="submit"
            className={styles.sendButton}
            disabled={isSending}
          >
            {isSending ? 'Sending...' : 'Send Invite'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddInvite;




